/**
 * The initial point allowance used by the current product configuration.
 * Keep this in one place so the warning threshold can be adjusted with the
 * allowance when the billing model changes.
 */
export const POINTS_ALLOWANCE = 35_000;
export const LOW_POINTS_RATIO = 0.2;
export const LOW_POINTS_THRESHOLD = POINTS_ALLOWANCE * LOW_POINTS_RATIO;
export const LOW_POINTS_WARNING_STORAGE_KEY = 'low-points-warning-shown';
